import {
  colorsTopC,
  webConfigs,
  mobileConfigs,
  mainBallVelocities,
  textureByProvider,
} from '../plinkoCore/constants/plinkoConfigs';
import { isMobile } from '../../../core/helpers/isMobile';
import { plinkoBetsStore } from '../plinkoStore/gameStore';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { PlinkoSoundNames } from '../plinkoCore/constants/sounds';
import { getBallsConfigs, getFixedBallsCoordinates } from '../utility';
import { colorConfigs, ODDS_CONSTANTS } from '../plinkoCore/constants';
// import { createImgDom } from '../plinkoCore/helpers';
// import oddPocketSvg from '../assets/odd-pocket.svg';
import { BaseDrawer } from './BaseDrawer';
import { userInfoStore } from '../../../store/userInfoStore';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { isPG } from '../../../core/helpers/skinHelper';
import { applicationStore } from '../../../store/applicationStore';

// const oddPocketImg = createImgDom(oddPocketSvg);

export class GameDrawer extends BaseDrawer {
  constructor(configs) {
    super();
    this.configs = configs;
    this.mainBalls = [];
    this.fixedBalls = [];
    this.oddRanges = {};
    this.odds = [];
    this.oddText = [];
    this.colorOverlays = [];
    this.requestId = null;
    this.setCollisionStartEvents(this.handleBallsCollisionCallback);
  }

  switchTurboMode = () => {
    const increaseSpeed = () => {
      if (userSettingsStore.isTurboOn) {
        this.updateEngine(4);
        requestAnimationFrame(increaseSpeed);
      }
    };
    requestAnimationFrame(increaseSpeed);
  };

  setMainBall(path, info) {
    const renderItem = isPG()
      ? {
          sprite: {
            texture: textureByProvider(applicationStore.partnerSkin)[plinkoBetsStore.riskType].img,
          },
        }
      : {
          fillStyle: colorsTopC[plinkoBetsStore.riskType].circle,
        };
    const { distanceFromTop, mainBallRadius } = getBallsConfigs(plinkoBetsStore.linesCount);
    const mainBall = this.createCircle(
      this.configs.width / 2,
      distanceFromTop,
      mainBallRadius,
      {
        isStatic: false,
        label: 'mainBall',
        mass: 50,
        density: 1,
        info,
        path,
        collidedBodies: [],
        restitution: 2,
        friction: 0,
        frictionAir: 0,
        frictionStatic: 0,
        angularVelocity: 0,
        angularSpeed: 0,
        yVelocity: mainBallVelocities[plinkoBetsStore.linesCount].y,
        rowIndex: -1,
        xVelocity: mainBallVelocities[plinkoBetsStore.linesCount].x,
        collisionFilter: {
          category: 0x0002,
          mask: 0x0001,
        },
        render: renderItem,
      },
      true
    );
    const innerBall = this.createCircle(
      mainBall.position.x + mainBall.circleRadius / 4,
      mainBall.position.y - mainBall.circleRadius / 4,
      mainBall.circleRadius / 4,
      {
        isStatic: false,
        mass: 0,
        density: 0.0001,
        restitution: 0,
        isSleeping: true,
        label: 'innerBall',
        friction: 0,
        collisionFilter: {
          category: 0x0003,
          mask: 0,
        },
        render: {
          fillStyle: isPG() ? 'rgba(255,255,255,0)' : 'rgba(243,243,243,0.95)',
        },
      },
      true
    );

    const constraint = this.createConstraint({
      bodyA: mainBall,
      pointA: { x: mainBall.circleRadius / 4, y: -mainBall.circleRadius / 4 }, // Relative position inside the outer ball
      bodyB: innerBall,
      pointB: { x: 0, y: 0 },
      render: {
        strokeStyle: 'rgba(255,255,255,0.91)',
        visible: false,
      },
    });

    mainBall.innerBall = innerBall;
    mainBall.constraint = constraint;

    this.mainBalls.push(mainBall);

    this.addToWorld(constraint);
  }

  handleRemoveBalls() {
    this.mainBalls.forEach((ball) => {
      this.removeFromWorld(ball);
      this.removeFromWorld(ball.innerBall);
      this.removeFromWorld(ball.constraint);
      this.removeFromWorld(ball.gravityArea);
    });
    this.mainBalls = [];
  }

  setBangBall(position, radius) {
    const colors = isPG() ? textureByProvider(applicationStore.partnerSkin) : colorsTopC;
    const ball = this.createCircle(
      position.x,
      position.y,
      radius,
      {
        isStatic: true,
        mass: 10,
        label: 'bangBall',
        isSleeping: true,
        density: 1,
        restitution: 0,
        friction: 0,
        collisionFilter: {
          category: 0x0002,
          mask: 0,
        },
        render: {
          fillStyle: colors[plinkoBetsStore.riskType].bangCircleRGB,
          opacity: 0.45,
        },
      },
      true
    );

    const bounce = () => {
      if (ball.circleRadius >= radius * 2.5) {
        return this.removeFromWorld(ball);
      }
      ball.circleRadius += radius / 15;
      ball.render.opacity -= ball.render.opacity - 0.01 < 0 ? 0 : 0.01;

      return requestAnimationFrame(bounce);
    };
    requestAnimationFrame(bounce);
  }

  handleRemoveOddsBody() {
    if (this.colorOverlays.length) {
      this.colorOverlays.forEach((item, index) => {
        this.removeFromWorld(item);
        this.removeEvents(this.render, 'afterRender', this.oddText[index]);
      });
      // this.oddPockets = [];
      this.oddText = [];
      this.colorOverlays = [];
    }
  }

  handleBallsCollisionCallback = (event) => {
    const { pairs } = event;
    pairs.forEach((pair) => {
      const { bodyA } = pair;
      const { bodyB } = pair;

      if (this.mainBalls.length > 2) {
        soundService.play(PlinkoSoundNames.bumpingMore2, true);
      } else {
        soundService.stop(PlinkoSoundNames.bumpingMore2);
        // soundService.stop(PlinkoSoundNames.bumping);
        soundService.playInDuration(PlinkoSoundNames.bumping, true, 0, 0.15);
      }
      // this.setAngularSpeed(bodyB, 0);
      this.setVelocity(bodyB, { x: 0, y: 0 });

      const mainBall = bodyA.label === 'mainBall' ? bodyA : bodyB;
      const fixedBall =
        bodyA.label === 'fixedBall' && bodyA.label !== 'colorOverlay' ? bodyA : bodyB;

      if ((bodyA && bodyB) || (bodyA === bodyB && bodyB === bodyA)) {
        if (
          this.mainBalls.length < 5 &&
          !userSettingsStore.isTurboOn &&
          bodyA.label !== 'colorOverlay'
        ) {
          this.setBangBall(fixedBall.position, fixedBall.circleRadius);
        }
        if (bodyA.label === 'colorOverlay' || bodyB.label === 'colorOverlay') {
          const ball = bodyA.label === 'colorOverlay' ? bodyB : bodyA;
          const odd = bodyA.label !== 'colorOverlay' ? bodyB : bodyA;
          this.setPosition(odd, odd.position.x, odd.position.y + 10);
          this.removeFromWorld(ball);
          this.removeFromWorld(ball.innerBall);
          this.removeFromWorld(ball.constraint);
          this.removeFromWorld(ball.gravityArea);
          setTimeout(() => {
            if (!this.mainBalls.length && plinkoBetsStore.isHaveCirclesInPlinko) {
              soundService.stop(PlinkoSoundNames.bumping);
              soundService.stop(PlinkoSoundNames.bumpingMore2);
              plinkoBetsStore.setIsHaveCirclesInPlinko(false);
            } else if (this.mainBalls.length && !plinkoBetsStore.isHaveCirclesInPlinko) {
              plinkoBetsStore.setIsHaveCirclesInPlinko(true);
            }

            if (this.mainBalls.length > (isMobile() ? 10 : 30)) {
              plinkoBetsStore.setIsAllowedNextBet(false);
            } else {
              plinkoBetsStore.setIsAllowedNextBet(true);
            }
            this.setPosition(odd, odd.position.x, odd.position.y - 10);
          }, 50);
          soundService.play(PlinkoSoundNames.win, true).then(() => {
            setTimeout(() => {
              plinkoBetsStore.updateLastResults(ball.info.result);
            }, 500);
          });
          if (ball.info.isAllowedBalanceUpdate) {
            setTimeout(() => {
              userInfoStore.getBalance();
            }, 2500);
            betHistoryStore.getLastBet();
            checkHashStore.setLastRoundInfo(ball.info);
            checkHashStore.setLastRoundResult({
              balls: ball.info.balls,
            });
            checkHashStore.setNextRoundHash(ball.info.newHash);
          }
          this.mainBalls = this.mainBalls.filter((currentBall) => currentBall !== ball);
        }
      }

      if (mainBall.collidedBodies?.includes(fixedBall)) {
        this.setVelocity(mainBall, { x: 0, y: 0 });
        return;
      }
      mainBall.collidedBodies.push(fixedBall);

      if (mainBall.rowIndex < fixedBall.rowIndex) {
        if (mainBall.gravityArea) {
          this.removeFromWorld(mainBall.gravityArea);
        }

        mainBall.rowIndex = fixedBall.rowIndex;
        mainBall.lastCollided = fixedBall;

        const halfWidthBetween = getBallsConfigs(plinkoBetsStore.linesCount).widthBetweenLines / 2;

        mainBall.gravityArea = this.createConstraint(
          {
            pointA: {
              x: fixedBall.position.x + halfWidthBetween * mainBall.path[mainBall.rowIndex],
              y: fixedBall.position.y + 10,
            },
            bodyB: mainBall,
            stiffness: 0.001,
            length: 1,
            render: {
              visible: false,
            },
          },
          true
        );
        setTimeout(() => {
          this.setVelocity(mainBall, {
            x: mainBall.xVelocity * mainBall.path[mainBall.rowIndex],
            y: mainBall.yVelocity,
          });
        }, 0);
      }

      if (mainBall.rowIndex === fixedBall.rowIndex && mainBall.lastCollided !== fixedBall) {
        if (mainBall.path[mainBall.rowIndex] === mainBall.path[mainBall.rowIndex + 1]) {
          this.setVelocity(mainBall, {
            x: (-mainBall.xVelocity / 2) * mainBall.path[mainBall.rowIndex + 1],
            y: -1.3,
          });
        } else {
          this.setVelocity(mainBall, {
            x: 0,
            y: bodyB.velocity.y / 2,
          });
        }
      }
    });
  };

  cleanFixedBalls() {
    this.fixedBalls.forEach((circle) => {
      this.removeFromWorld(circle);
    });
    this.fixedBalls = [];
  }

  setOddsContainer2(lines) {
    const odds = plinkoBetsStore.getOddsArray();
    const { riskType } = plinkoBetsStore;
    if (!this.mainBalls.length && plinkoBetsStore.isHaveCirclesInPlinko) {
      soundService.stop(PlinkoSoundNames.bumping);
      soundService.stop(PlinkoSoundNames.bumpingMore2);
      plinkoBetsStore.setIsHaveCirclesInPlinko(false);
    } else if (this.mainBalls.length && !plinkoBetsStore.isHaveCirclesInPlinko) {
      plinkoBetsStore.setIsHaveCirclesInPlinko(true);
    }

    if (this.mainBalls.length > (isMobile() ? 10 : 30)) {
      plinkoBetsStore.setIsAllowedNextBet(false);
    } else {
      plinkoBetsStore.setIsAllowedNextBet(true);
    }
    let currentX = this.fixedBalls[this.fixedBalls.length - 1].position.x;
    let currentY = this.fixedBalls[this.fixedBalls.length - 1].position.y;
    const { heightBetweenLines } = getBallsConfigs(lines);
    const currentXDistance = getBallsConfigs(lines).widthBetweenLines;
    const mistakeX = 2.5;

    const grd = this.render.context.createRadialGradient(
      this.configs.width / 2,
      currentY + heightBetweenLines / 2.3,
      5,
      this.configs.width / 2,
      currentY + heightBetweenLines / 2.3,
      190
    );
    grd.addColorStop(0, colorConfigs(applicationStore.partnerSkin)[riskType].color1);
    grd.addColorStop(1, colorConfigs(applicationStore.partnerSkin)[riskType].color2);

    for (let j = 0; j <= lines; j += 1) {
      this.oddRanges[odds[j]] = [...[currentX, currentX + currentXDistance - mistakeX]];
      currentY = this.fixedBalls[this.fixedBalls.length - 1].position.y;

      const currentXRange = [currentX, currentX + currentXDistance - mistakeX];
      this.oddRanges[odds[j]] = [...currentXRange];

      const drawingY = currentY + heightBetweenLines / 2.3;

      // const oddPocket = this.createRectangle(
      //   currentX + mistakeX + (currentXDistance * ODDS_CONSTANTS.oddPocketWidthMultiplier) / 2,
      //   drawingY + (currentXDistance * ODDS_CONSTANTS.oddPocketHeightMultiplier) / 2,
      //   currentXDistance * ODDS_CONSTANTS.oddPocketWidthMultiplier,
      //   currentXDistance * ODDS_CONSTANTS.oddPocketHeightMultiplier,
      //   {
      //     isStatic: true,
      //     label: 'oddPocket',
      //     strokeStyle: isPG() ? 'rgb(16,20,25)' : '#161618',
      //     render: {
      //       sprite: {
      //         texture: oddPocketSvg,
      //       },
      //     },
      //   }
      // );

      const colorOverlay = this.createRectangle(
        currentX + mistakeX + (currentXDistance * ODDS_CONSTANTS.oddPocketWidthMultiplier) / 2,
        drawingY + (currentXDistance * ODDS_CONSTANTS.oddPocketHeightMultiplier) / 2,
        currentXDistance * ODDS_CONSTANTS.oddPocketWidthMultiplier,
        currentXDistance * ODDS_CONSTANTS.oddPocketHeightMultiplier,
        {
          isStatic: true,
          label: 'colorOverlay',
          chamfer: { radius: 5 },
          render: {
            fillStyle: grd,
          },
        }
      );

      const oddText = this.addEvents(this.render, 'afterRender', () => {
        const { context } = this.render;
        const { x, y } = colorOverlay.position;
        // eslint-disable-next-line
        context.fillStyle = '#FFFFFF'; // Set text color
        context.font = `${currentXDistance / (isPG() ? 3 : 3.6)}px Arial`; // Set font size and style
        context.textBaseline = 'middle';
        context.textAlign = 'center';
        context.fillText(`${odds[j]}${isPG() ? '' : 'x'}`, x, y);
      });

      this.oddText.push(oddText);
      // this.oddPockets.push(oddPocket);
      this.colorOverlays.push(colorOverlay);
      this.addToWorld(colorOverlay);

      currentX += currentXDistance;
    }
  }

  setupFixedBalls(lines) {
    cancelAnimationFrame(this.requestId);
    this.cleanFixedBalls();
    this.handleRemoveOddsBody();
    const fixedBallsCoordinates = getFixedBallsCoordinates(lines, this.configs);
    let rowIndex = 0;
    for (let i = 0; i < fixedBallsCoordinates.length; i += 1) {
      if (fixedBallsCoordinates[i].y > fixedBallsCoordinates[i - 1]?.y) {
        rowIndex += 1;
      }

      const fixedBall = this.createCircle(
        fixedBallsCoordinates[i].x,
        fixedBallsCoordinates[i].y,
        getBallsConfigs(lines).fixedBallRadius,
        {
          isStatic: true,
          mass: 50,
          density: 1,
          rowIndex,
          label: 'fixedBall',
          restitution: 0,
          friction: 0,
          collisionFilter: {
            category: 0x0001, // Use a unique category for ballA
            mask: 0x0002, // Collide with bodies in category 0x0002 (anything other than itself)
          },
          render: {
            fillStyle: '#ffffff',
          },
        },
        true
      );
      this.fixedBalls.push(fixedBall);
    }
    this.setOddsContainer2(lines);
  }

  execute(rootRef) {
    this.createApplication(rootRef, { ...this.configs, gravityY: 1.5 });
    this.oddRanges = {};
  }
}

export const gameDrawer = new GameDrawer(isMobile() ? mobileConfigs : webConfigs);
